import type { PlatformModel } from 'src/types/platform';

import { useState, useEffect, useCallback } from 'react';

import axios, { endpoints } from 'src/lib/axios';

interface PaginatedRequest {
  page: number;
  pageSize: number;
  name?: string;
}

export default function usePlatforms() {
  const [platforms, setPlatforms] = useState<PlatformModel[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchPlatforms = useCallback(async (searchTerm?: string) => {
    try {
      setLoading(true);
      setError(null);

      const requestBody: PaginatedRequest = {
        page: 1,
        pageSize: 100,
        name: searchTerm || undefined,
      };

      const response = await axios.post(endpoints.platforms.getAll, requestBody);

      let platformData: PlatformModel[] = [];

      if (Array.isArray(response.data)) {
        platformData = response.data;
      } else if (response.data && Array.isArray(response.data.items)) {
        platformData = response.data.items;
      } else if (response.data && Array.isArray(response.data.results)) {
        platformData = response.data.results;
      } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
        platformData = response.data.data;
      } else {
        console.error('El formato de respuesta no es válido:', response.data);
        platformData = [];
      }

      setPlatforms(platformData);
    } catch (err) {
      console.error('Error al cargar las plataformas:', err);
      setError('Error al cargar las plataformas');
      setPlatforms([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Ejecutar fetchPlatforms inmediatamente al montar el componente
  useEffect(() => {
    fetchPlatforms();
  }, []);

  return {
    platforms,
    loading,
    error,
    onSearchPlatform: fetchPlatforms,
  };
}
